<template>
  <div class="ultrazaem">
    <checker-offers-block :offers="checkerDisplayOffers" />
    <div class="showcase-wrapper" :class="{ 'showcase-wrapper--no-swiper': !isSwiperEnabled }">
      <div v-if="isSwiperEnabled" class="swiper-pagination" ref="pagination"></div>
      <div v-if="isSwiperEnabled" class="swiper-text__label">Листайте влево</div>

      <div class="swiper showcase-swiper" ref="swiper">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="offer in mobileSwiperDisplayOffers" :key="offer.__mobileSwiperLoopKey || offer.id || offer.link || offer.name">
            <div class="card">

              <div class="card-rating">
                <span class="card-rating__star">★</span>
                <span class="card-rating__value">{{ offer.rating }}</span>
              </div>
              <div class="card-top">
                <img :src="'https://zanimakus.ru' + offer.logo" alt="" />
              </div>
              <!-- <div class="card-info__rate">
                <star-rating :max="5" :current="offer.rating"></star-rating>
              </div> -->

              <div class="card-info">
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/usum.svg" alt="">
                  </div>
                  <div class="card-info__value">до {{ numberFormat(offer.amount) }} ₽</div>
                </div>
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/uperiod.svg" alt="">
                  </div>
                  <div class="card-info__value">до {{ offer.period }} дней</div>
                </div>
                <div class="card-info__wrapper">
                  <div class="card-info__img">
                    <img src="/img/upercent.svg" alt="">
                  </div>
                  <div class="card-info__value">без % - <span v-if="offer.without_percent">да</span>
                    <span v-if="!offer.without_percent">нет</span>
                  </div>
                </div>
              </div>

              <!-- Кнопка -->
              <div class="card-btn" @click="openLinks(offer)">
                <button type="button">ПОЛУЧИТЬ ЗАЕМ</button>
              </div>
            </div>
          </div>
        </div>

        <button v-if="isSwiperEnabled" class="showcase-nav prev" ref="prevBtn" :class="{ hidden: !hasMovedFromFirst }">‹</button>
        <button v-if="isSwiperEnabled" class="showcase-nav next" ref="nextBtn">›</button>
      </div>
    </div>

  </div>
</template>

<script>
import * as Functions from "../assets/js/functions.js";
import * as Data from "../assets/js/data_params.js";
import StarRating from "@/components/StarRating";
import offerBucketsMixin from "../assets/js/offerBucketsMixin.js";
import mobileSwiperMixin from "../assets/js/mobileSwiperMixin.js";
import CheckerOffersBlock from "./CheckerOffersBlock.vue";
export default {
  name: "ShowcaseUltrazaem",
  mixins: [offerBucketsMixin, mobileSwiperMixin],
  components: {
    StarRating,
    CheckerOffersBlock,
  },
  props: {
    offers: Array,
  },

  data: () => ({
    ratingText: Data.getRatingText(),
    buttonText: Data.getButtonText(),
  }),

  computed: {
    filteredOffers() {
      return this.getInlineOrderedOffers(this.displayedOffers);
    },

    checkerDisplayOffers() {
      return this.getCheckerDisplayOffers();
    },

    showcaseOffers() {
      return this.getInlineShowcaseOffers(this.filteredOffers);
    },
  },

  methods: {
    //Форматирование сумм
    numberFormat(num) {
      return Functions.numberFormat(num);
    },

    //Добавить нули после запятой
    toFixed(num) {
      return num.toFixed(1);
    },
    openLinks(offer) {
      window.open(offer.link, "_blank");
      offer.links.forEach((link) => {
        window.open(link, "_blank");
      });
    },
  },
};
</script>
<style lang="css">
@import url(../assets/css/ultrazaem.scss);
</style>
<style lang="css">
.star-rating {
  width: 50%;
}

.ozzaym .card-info__wrapper {


  display: flex;
  align-items: center;


}

.card-info__rate {
  margin-left: 30px;
  margin-bottom: 15px;
  width: 100%;
}


.swiper-text__label {
  display: none;
}

@media (max-width: 768px) {
  .swiper-text__label {
    display: block;
    font-weight: 400;
    font-size: 16px;
  }

  .showcase-nav.hidden {
    opacity: 0;
    pointer-events: none;
  }
}

.ultrazaem .showcase-wrapper--no-swiper .showcase-swiper {
  overflow: visible;
  width: 100%;
}

.ultrazaem .showcase-wrapper--no-swiper .swiper-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  transform: none !important;
}

.ultrazaem .showcase-wrapper--no-swiper .swiper-slide {
  display: flex;
  width: auto;
}

@media (max-width: 767px) {
  .ultrazaem .showcase-wrapper {
    padding: 0 0 20px;
  }

  .ultrazaem .showcase-wrapper--no-swiper .swiper-wrapper {
    flex-direction: column;
    flex-wrap: nowrap;
    gap: 0;
  }

  .ultrazaem .showcase-wrapper--no-swiper .swiper-slide,
  .ultrazaem .showcase-wrapper--no-swiper .card {
    width: 100%;
    max-width: 100%;
  }

  .ultrazaem .showcase-wrapper > .swiper-pagination {
    display: block;
    position: relative;
    max-width: 310px;
    width: 100%;
    height: 6px;
    margin: 0 auto 16px;
    background: #e5e5e5;
    border-radius: 999px;
    overflow: hidden;
  }

  .ultrazaem .showcase-wrapper > .swiper-pagination .swiper-pagination-progressbar-fill {
    background: #1A8F11;
    transform-origin: left center;
    transition: transform .25s ease;
    width: 100%;
    height: 100%;
    transform: scaleX(0);
  }

  .ultrazaem .showcase-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 29px;
    height: 29px;
    color: #fff;
    background: #1A8F11;
    border-radius: 50%;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    cursor: pointer;
  }

  .ultrazaem .showcase-nav.prev {
    left: 0;
  }

  .ultrazaem .showcase-nav.next {
    right: 0;
  }
}
</style>
